export default __webpack_public_path__ + "static/media/heat-meter.e87f3d69.svg";